<template>
  <div id="AttendanceICAReport">
    <div id="Filter" class="container p-4">
      <K2Filter :filter-list="filterList" :dateType="dateType" @onFilter="handleFilter" @onFilterChange="onFilterChange" />
    </div>
    <div id="ReportHtml" class="container" v-if="Data.length != 0">
      <div class="row header mb-5">
        <div>The report would be sent to your email. Please check your email in 15 mins</div>
      </div>
      <ReportContent :Data="Data" :fromDate="fromDate" :toDate="toDate" :studentTypes="studentType" />
    </div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1500"
      filename="myPDF"
      :pdf-quality="2"
      :manual-pagination="false"
      1
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="=800px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div id="ReportHtml" class="container" v-if="Data.length != 0">
          <ReportContent :Data="Data" :fromDate="fromDate" :toDate="toDate" />
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import { lang } from '@/locale'
import Cookies from 'js-cookie'
import DataSource from '@/data/datasource'
import K2Button from '@/uiComponents/k2Button/k2Button'
import K2Heading from '@/uiComponents/k2Heading/k2Heading'
import K2Row from '@/uiComponents/k2Row/k2Row'
import K2Filter from '@/uiComponents/k2Filter/k2Filter'
import AlumniReportTable from '@/pages/alumniReport/component/alumniReportTable'
import VueHtml2pdf from 'vue-html2pdf'
import uiVariable from '@/config/uiVariable'
import ReportContent from './ReportContent'

export default {
  name: 'StudentAttendanceReport',
  components: { K2Button, K2Heading, K2Row, K2Filter, VueHtml2pdf, ReportContent },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.getSchools()
    await this.getStudentTypes()
  },
  data() {
    return {
      uiVariable: uiVariable,
      dateRange: null,
      dateType: 'daterange',
      fromDate: '',
      toDate: '',
      selectedSchool: '',
      studentType: '',

      studentTypes: [],

      filterList: [
        {
          label: 'Schools',
          placeholder: 'Filter by Schools',
          optionList: [],
        },
        {
          label: 'Date',
          placeholder: 'Filter by date',
          selected: [],
        },
        {
          label: 'StudentType',
          placeholder: 'All Students',
          optionList: [],
        },
      ],
      Data: [],
    }
  },
  methods: {
    lang,
    async loadReport() {
      this.$vs.loading()
      try {
        const response = await DataSource.shared.GetAttendanceReport(this.fromDate, this.toDate, this.selectedSchool, this.studentType)
        if (response) {
          this.Data = response.Student
          console.log(this.Data)
        }
      } catch (e) {
        this.results = e
        console.log(e)
      }
      this.$vs.loading.close()
    },
    splitDates() {
      let dateSplit = this.dateRange.split(',')
      this.fromDate = dateSplit[0]
      this.toDate = dateSplit[1]
    },

    async getSchools() {
      const response = await DataSource.shared.getSchoolDropdownList('UTY201300000061')
      if (response) {
        response.Table.forEach(d => {
          d.id = d.SchoolID
          d.label = d.SchoolName
          d.type = 'school'
        })
      }
      this.filterList[0].optionList = response.Table
    },
    async getStudentTypes() {
      try {
        let jsonString = '"Residency Status":"Residency Status"'
        jsonString = '{' + jsonString + '}'
        const response = await DataSource.shared.getStudentDropDownList(jsonString)

        if (response) {
          response.Table.forEach(d => {
            d.id = d.OPTvalue
            d.label = d.OPTvalue
            d.type = 'student type'
          })
          this.filterList[2].optionList = response.Table
        }
      } catch (e) {
        this.results = e
      }
    },

    handleFilter(type) {
      if (this.filterList[0].selected !== undefined) {
        this.selectedSchool = this.filterList[0].selected.toString()
      }
      if (this.filterList[1].selected !== undefined) {
        this.dateRange = this.filterList[1].selected.toString()
        this.splitDates()
      }
      if (this.filterList[2].selected !== undefined) {
        this.studentType = this.filterList[2].selected.toString()
      }

      this.loadReport()
    },
    onFilterChange(value) {
      console.log(type)
      this.getClass(value)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
  },
}
</script>

<style scoped></style>
